module.exports = __webpack_public_path__ + "img/landing_never2.f3c7f5ac.png";